import { Bell, Palette, UserRound, type LucideIcon } from "lucide-react";

/**
 * The settings category descriptors. One list drives the side nav
 * (`expanded`+), the pill bar (`medium`), the category list (`compact`), and
 * the route table. Add a category here and in `settingsRoutes.tsx`.
 */

export const SETTINGS_ROOT = "/settings";

/** Content column cap. Narrower than the admin cap: settings are prose + controls. */
export const SETTINGS_CONTENT_MAX_WIDTH = 760;
/** Side nav measure on `expanded`+. */
export const SETTINGS_NAV_WIDTH = 224;

export interface SettingsNavEntry {
    readonly id: string;
    readonly label: string;
    /** One line under the label on the compact category list. */
    readonly description: string;
    readonly icon: LucideIcon;
    readonly to: string;
}

export const SETTINGS_NAV_ENTRIES: readonly SettingsNavEntry[] = [
    {
        id: "appearance",
        label: "Appearance",
        description: "Theme and motion",
        icon: Palette,
        to: `${SETTINGS_ROOT}/appearance`,
    },
    {
        id: "notifications",
        label: "Notifications",
        description: "Push alerts for this device and your queues",
        icon: Bell,
        to: `${SETTINGS_ROOT}/notifications`,
    },
    {
        id: "account",
        label: "Account",
        description: "Signed-in identity, admin, sign out",
        icon: UserRound,
        to: `${SETTINGS_ROOT}/account`,
    },
];

export function isSettingsEntryActive(pathname: string, entry: SettingsNavEntry): boolean {
    return pathname === entry.to || pathname.startsWith(`${entry.to}/`);
}
